import React, { useState, useEffect } from "react";
import Loader from "react-loader-spinner";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { onMessageListener } from "../../utils/pushNotification";

import { getToken } from "../../utils/pushNotification";
import * as userAuthActions from "../../Redux/Actions/user";
import * as notificationActions from "../../Redux/Actions/notification";
import { toastMessage } from "../../utils/toast";
import { clearSession } from "../../utils/initiate";
import * as localizationActions from "../../Redux/Actions/localization";
import SendOTPModal from "../Ui/SendOTPModal/SendOTPModal";
import ForgotPasswordModal from "../Ui/ForgotPasswordModal/ForgotPasswordModal";
import NeedHelpModal from "../Ui/NeedHelpModal/NeedHelpModal";
import { getLocaleValue } from "../../utils";

const eye = <FontAwesomeIcon icon={faEye} />;
const eyeSlash = <FontAwesomeIcon icon={faEyeSlash} />;

const Login = ({ history }) => {
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [fcmToken, setFcmToken] = useState("");
  const [buttonLoading, setButtonLoading] = useState(false);
  const [passWordShown, setPassWordShown] = useState(false);
  const [showSendOTPModal, setShowSendOTPModal] = useState(false);
  const [showForgotPasswordModal, setShowForgotPasswordModal] = useState(false);
  const [showHelpModal, setShowHelpModal] = useState(false);
  const [currentLanguage, setCurrentLanguage] = useState(
    localStorage.getItem("i18nextLng")
  );

  onMessageListener().then(payload => {
    console.log(payload);
}).catch(err => console.log('failed: ', err));

  useEffect(() => {
    //To Get English Localizations
    localizationActions
      .localization("EN")
      .then((res) => {
        if (res) {
          setTimeout(() => {
            localStorage.setItem("localEn", JSON.stringify(res));
          }, 10);
        } else {
          localStorage.setItem("localEn", "");
          toastMessage(
            "error",
            (res && res.message) || `Unable to load the eng Localization`
          );
        }
      })
      .catch((err) => {
        err.response?.status === 401 && clearSession(dispatch, history);
      });
    //-----------------------------------------------------------------------------------------------------
    //To Get Arabic Localizations
    localizationActions
      .localization("AR")
      .then((res) => {
        if (res) {
          localStorage.setItem("localAr", JSON.stringify(res));
        } else {
          localStorage.setItem("localAr", "");
          toastMessage(
            "error",
            (res && res.message) || `Unable to load the ar Localization`
          );
        }
      })
      .catch((err) => {
        err.response?.status === 401 && clearSession(dispatch, history);
      });

    getToken(setFcmToken);
  }, []);

  const changeLanguage = (value) => {
    i18n.changeLanguage(value);
    setCurrentLanguage(value);
  };

  const handleUserLogin = () => {
    setButtonLoading(true);
    let payload = {
      userName: email,
      password: password,
      fcmToken: "",
    };
    if (email !== "" && password !== "") {
      userAuthActions
        .userLogin(payload)
        .then((res) => {
          if (res && res.status === 200) {
            let jwtResponse = parseJwt(res.data.data.token);
            localStorage.setItem("jwt", res.data.data.token);
            dispatch(userAuthActions.userData(jwtResponse));
            history.push("/home");
            setButtonLoading(false);

            let payload = {
              id: res.data.data.id,
              fcmToken,
            };

            fcmToken != "" &&
              notificationActions.updateToken(payload).then((res) => {
                localStorage.setItem("fcmToken", fcmToken);
                if (res && res.data) {
                  toastMessage("success", "Your notification status updated");
                } else {
                  toastMessage("error", "Unable to update the FCM token");
                }
              });
          }
        })
        .catch((err) => {
          setErrorMsg(err.response?.data?.message);
          setButtonLoading(false);
        });
    } else {
      setButtonLoading(false);
      setErrorMsg("Enter the correct user name and password");
    }
  };

  const parseJwt = (token) => {
    var base64Url = token.split(".")[1];
    var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    var jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map(function (c) {
          return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join("")
    );

    return JSON.parse(jsonPayload);
  };

  return (
    <div className="account-body d-flex flex-column justify-content-center vw-100">
      <div
        className="logo logo-admin position-absolute"
        style={{ left: "60px", top: 0 }}
      >
        <img
          src="/Assets/aamer_logo.jpg"
          width="150px"
          height="auto"
          alt="logo"
          className="auth-logo"
        />
      </div>
      <div className="position-absolute" style={{ right: "10px", top: -40 }}>
        <div style={{ marginTop: "60px", marginRight: "60px" }}>
          <span
            style={{
              fontSize: "20px",
              color: "#b71c1c",
              cursor: "pointer",
              borderBottom: currentLanguage == "english" ? "2px solid" : "0px",
              fontWeight: "bold",
            }}
            onClick={() => {
              changeLanguage("english");
            }}
          >
            EN
          </span>
          <span
            style={{
              marginLeft: "10px",
              marginRight: "10px",
              fontSize: "20px",
              color: "#b71c1c",
              fontWeight: "bold",
            }}
          >
            |
          </span>
          <span
            style={{
              fontSize: "20px",
              color: "#b71c1c",
              cursor: "pointer",
              borderBottom: currentLanguage == "arabic" ? "2px solid" : "0px",
              fontWeight: "bold",
            }}
            onClick={() => {
              changeLanguage("arabic");
            }}
          >
            AR
          </span>
        </div>
      </div>
      <div className="container">
        <div className="row d-flex justify-content-center">
          <div className="col-12 align-self-center">
            <div className="row">
              <div className="col-lg-5 mx-auto" style={{ marginTop: "-30px" }}>
                <div className="card">
                  <div className="card-body p-0 auth-header-box">
                    <div className="text-center p-3">
                      <h4 className="mt-3 mb-3 fw-semibold text-white font-30">
                        Aamer Customer App
                      </h4>
                      <p className="mb-0 font-20" style={{ color: "#b71c1c" }}>
                        Sign in to continue to Aamer Customer App
                      </p>
                    </div>
                  </div>
                  <div className="card-body p-0">
                    {/* <ul className="nav-border nav nav-pills">
                                            <li className="nav-item">
                                                <p className="nav-link active fw-semibold m-0 c-pointer ms-2 font-20" style={{lineHeight: '33px'}}>{getLocaleValue("startup_login")}</p>
                                            </li>
                                        </ul> */}
                    <div className="tab-content">
                      <div className="tab-pane active p-3" role="tabpanel">
                        <div className="form-horizontal auth-form">
                          <div className="form-group mb-2">
                            <label
                              className="form-label font-18"
                              htmlFor="username"
                            >
                              {getLocaleValue("login_user_name")}
                            </label>
                            <div className="input-group">
                              <input
                                type="text"
                                className="form-control"
                                name="username"
                                placeholder="Enter username"
                                value={email}
                                onChange={(e) => {
                                  setEmail(e.target.value);
                                  setErrorMsg("");
                                }}
                              />
                            </div>
                          </div>

                          <div className="form-group mb-2">
                            <label
                              className="form-label font-18"
                              htmlFor="userpassword"
                            >
                              {getLocaleValue("login_password")}
                            </label>
                            <div className="input-group">
                              <input
                                type={passWordShown ? "text" : "password"}
                                className="form-control"
                                name="password"
                                placeholder="Enter password"
                                value={password}
                                onKeyPress={(e) =>
                                  e.charCode === 13 ? handleUserLogin() : ""
                                }
                                onChange={(e) => {
                                  setPassword(e.target.value);
                                  setErrorMsg("");
                                }}
                              ></input>
                              <div className="input-group-btn">
                                <button
                                  tabIndex="-1"
                                  className="btn btn-outline-primary"
                                  onClick={() => {
                                    setPassWordShown(!passWordShown);
                                  }}
                                >
                                  {passWordShown ? (
                                    <i>{eye}</i>
                                  ) : (
                                    <i>{eyeSlash}</i>
                                  )}
                                </button>
                              </div>
                            </div>
                          </div>
                          {(errorMsg || email === "" || password === "") && (
                            <p className="text-danger mt-2 text-center font-weight-bold">
                              {errorMsg}
                            </p>
                          )}
                          <div className="form-group row justify-content-end mb-3">
                            {/* <div className="col-sm-6">
                                                            <div className="custom-control custom-switch switch-success d-flex align-items-center">
                                                                <input type="checkbox" className="custom-control-input" checked={rememberMe} onChange={e => setRememberMe(e.target.checked)} />
                                                                <label className="form-label text-muted m-0 ms-1" htmlFor="customSwitchSuccess">Remember me</label>
                                                            </div>
                                                        </div> */}
                            <div className="col-sm-6 text-end">
                              <p
                                className="text-muted font-18 c-pointer"
                                onClick={() => {
                                  setShowForgotPasswordModal(true);
                                }}
                              >
                                <i className="dripicons-lock"></i>{" "}
                                {getLocaleValue("login_forgot_password") + " ?"}
                              </p>
                            </div>
                          </div>

                          <div className="form-group mb-0 row">
                            <div className="col-12">
                              <button
                                className="col-md-4 btn btn-primary w-100 waves-effect waves-light d-flex align-items-center justify-content-center font-18"
                                type="button"
                                disabled={buttonLoading}
                                onClick={handleUserLogin}
                              >
                                {getLocaleValue("login_header")}{" "}
                                {buttonLoading && (
                                  <Loader
                                    type="Oval"
                                    color="#fff"
                                    height={20}
                                    width={20}
                                    style={{ marginLeft: "10px" }}
                                  />
                                )}
                              </button>
                            </div>
                          </div>
                          {/* <div style={{marginTop:'20px'}}>
                                                        <div className="form-group mb-0 row">
                                                            <div className="col-12" >
                                                                <button className="btn btn-primary w-100 waves-effect waves-light d-flex align-items-center justify-content-center" type="button" disabled={button2Loading} onClick={() => {setShowRegisterModal(true);}}>
                                                                
                                                                    Register {button2Loading && <Loader type="Oval" color="#fff" height={20} width={20} style={{marginLeft: '10px'}} />}
                                                                </button>
                                                            </div> 
                                                        </div>
                                                    </div> */}
                          <div
                            className="card-body p-0 w-100"
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <div style={{ marginTop: "20px" }}>
                              <div className="form-group mb-0">
                                <div className="col-8">
                                  <button
                                    className="btn btn-primary waves-effect waves-light d-flex align-items-center justify-content-center font-18"
                                    type="button"
                                    onClick={() => {
                                      setShowSendOTPModal(true);
                                    }}
                                  >
                                    {getLocaleValue("usr_profile_otp")}
                                  </button>
                                </div>
                              </div>
                            </div>
                            <div style={{ marginTop: "20px" }}>
                              <div className="form-group mb-0">
                                <div className="col-12">
                                  <button
                                    className="btn btn-primary waves-effect waves-light d-flex align-items-center justify-content-center font-18"
                                    type="button"
                                    onClick={() => {
                                      setShowHelpModal(true);
                                    }}
                                  >
                                    Nead Help ?
                                  </button>
                                </div>
                              </div>
                            </div>
                            {/* <div style={{marginTop:'20px'}}>
                                                                    <div className="form-group mb-0">
                                                                        <div className="col-12" >
                                                                            <button className="btn btn-primary waves-effect waves-light d-flex align-items-center justify-content-center" type="button" disabled={button5Loading} onClick={ () => {setShowChatModal(true)}}>
                                                                                Chat ? {button5Loading && <Loader type="Oval" color="#fff" height={20} width={20} style={{marginLeft: '10px'}} />}
                                                                            </button>
                                                                        </div> 
                                                                    </div>
                                                                </div> */}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="card-body bg-light-alt text-center">
                    <span className="text-muted d-none d-sm-inline-block">
                      Aamer © 2021
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {showSendOTPModal && (
        <SendOTPModal
          t={t}
          handleCancel={() => {
            setShowSendOTPModal(false);
          }}
          history={history}
          showModal={showSendOTPModal}
          footerOption1={"Submit"}
          footerOption2={"Cancel"}
        >
          {" "}
        </SendOTPModal>
      )}
      {showForgotPasswordModal && (
        <ForgotPasswordModal
          t={t}
          handleCancel={() => {
            setShowForgotPasswordModal(false);
          }}
          history={history}
          showModal={showForgotPasswordModal}
          footerOption1={"Submit"}
          footerOption2={"Cancel"}
        >
          {" "}
        </ForgotPasswordModal>
      )}
      {showHelpModal && (
        <NeedHelpModal
          t={t}
          handleCancel={() => {
            setShowHelpModal(false);
          }}
          history={history}
          showModal={showHelpModal}
          footerOption1={"Submit"}
          footerOption2={"Cancel"}
          type={"help"}
        >
          {" "}
        </NeedHelpModal>
      )}
    </div>
  );
};

export default Login;
